import request from '../utils/request';

export function getStatisticsMiz343(params) {
  return request({
    url: '/api/company-objects/get-statistics-miz-343/',
    method: 'get',
    params
  })
}


export function getMaksamMonitoringOfObjects(params) {
  return request({
    url: '/api/orgs/maksam-monitoring-of-objects/',
    method: 'get',
    params: params
  })
}


export function getMaksamPollutionStats(params) {
  return request({
    url: '/api/orgs/maksam-polution-stats/',
    method: 'GET',
    params,
  })
}

export function getStatistics(params) {
  return request({
    url: '/api/company-objects/get_statistics_pkm/',
    method: 'GET',
    params,
  })
}
export function getStatisticsReport(params) {
  return request({
    url: '/api/company-objects/get_statistics_execution_report/',
    method: 'GET',
    params,
  })
}

export function getStatisticsReportmiz(params) {
  return request({
    url: '/api/company-objects/get_statistics_object_subject_miz/',
    method: 'GET',
    params,
  })
}
